<template>
  <div class="root">
    <template v-if="discount&&Number(discount.discount)!==10">
      <b class="left">{{discount.discount}}</b>
      <div class="right">
        <h1 class="">折倒计时{{discount.remainDays}}天</h1>
        <h2 class="">点击购票，立减{{discount.discountPrice}}</h2>
      </div>
    </template>
    <template v-else-if="discount&&Number(discount.discount)===10">
      <div class="wrapper">
        <h1 class="">报名倒计时{{discount.remainDays}}天</h1>
        <h2 class="">团购享更多优惠</h2>
      </div>
    </template>
    <template v-else>
      <div>
        <h1 v-if="data.title" v-html="data.title"></h1>
        <h2 v-if="data.subtitle" v-html="data.subtitle"></h2>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['data', 'price'],
  data () {
    return {
    }
  },
  computed: {
    discount () {
      if (!this.data.showDiscount) return false
      for (let i = 0; i < this.price.discount.length; i++) {
        let d = this.price.discount[i]
        let cur = moment()
        let end = moment(d.end)
        if (!cur.isAfter(end)) {
          let remainDays = moment(end).diff(cur, 'days') + 1
          let discountPrice = (this.price.price - d.price) / 100
          let discount = d.discount
          return { remainDays, discountPrice, discount }
        }
      }
      return false
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>
  @import "../../../assets/style/variable.sass"

  .root
    // width: 218px
    min-width: 190px
    height: 61px
    display: flex
    align-items: center
    justify-content: center
    color: #fff
    border-radius: 4px
    text-align: center
    padding-left: 15px
    padding-right: 15px
    line-height: 1.3
    box-shadow: 0px 2px 0.2px -1px rgba(0,0,0,0.6),0px 0px 4px 0px rgba(255,255,255,0.3) inset
    background: linear-gradient(0deg, #1f63af, #008ce6)
    transition: all $speed ease-in-out
    opacity: 0.9
    &:hover
      opacity: 1
  h1
    font-size: 20px
    font-weight: 500
  h2
    font-size: 14px
    font-weight: 500
  .left
    font-size: 52px
    font-weight: 700
  .right
    text-align: left
    margin-left: 8px

</style>
